import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
// import '../../index.css';
const SortPopup = ({ isVisible, handleSortClick, sortOption, onSortOptionChange, onClose, triggerRef,ismultipleassignment }) => {
  const popupRef = useRef(null);
  const globalState = useSelector((state) => state.globalState);
  const role = globalState?.role;
  const handleSortChange = (value) => {
    onSortOptionChange(value);
   if (typeof handleSortClick === "function") {
    handleSortClick(value);
  }
    // Close the popup after selection
    if (onClose) {
      onClose(false);
    }
  };

  // Handle click outside and keyboard events to close popup
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (popupRef.current && !popupRef.current.contains(event.target)) {
  //       if (onClose) {
  //         onClose(false);
  //       }
  //     }
  //   };

  //   const handleKeyDown = (event) => {
  //     if (event.key === 'Escape') {
  //       if (onClose) {
  //         onClose();
  //       }
  //     }
  //   };

  //   if (isVisible) {
  //     document.addEventListener('mousedown', handleClickOutside);
  //     document.addEventListener('keydown', handleKeyDown);
  //   }

  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //     document.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, [isVisible, onClose]);

  useEffect(() => {
    const handleClickOutside = (event) => {
        const clickedOutsidePopup = popupRef.current && !popupRef.current.contains(event.target);
        const clickedTrigger = triggerRef?.current && triggerRef.current.contains(event.target);

        // Close only if clicked outside BOTH the popup and the trigger
        if (clickedOutsidePopup && !clickedTrigger) {
            onClose?.(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            onClose?.(false);
        }
    };

    if (isVisible) {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleKeyDown);
    };
}, [isVisible, onClose, triggerRef]);

  return (
    <>
      {isVisible && (
        <div className="sort-popup-assignprocess" ref={popupRef}>
          <h3>Sort By:</h3>
          <label htmlFor="A-Z" onClick={() => handleSortChange("A-Z")} >
            <input
              type="radio"
              id="A-Z"
              value="A-Z"
              checked={sortOption === "A-Z"}
              onChange={() => handleSortChange("A-Z")}
              readOnly
            />
            A-Z
          </label>

          <label htmlFor="Z-A" onClick={() => handleSortChange("Z-A")} >
            <input
              type="radio"
              id="Z-A"
              value="Z-A"
              checked={sortOption === "Z-A"}
              readOnly
              onChange={() => handleSortChange("Z-A")}
            />
            Z-A
          </label>
          <label htmlFor="Newest" onClick={() => handleSortChange("Newest")} >
            <input
              type="radio"
              id="Newest"
              value="Newest"
              checked={sortOption === "Newest"}
              readOnly
              onChange={() => handleSortChange("Newest")}
            />
            Newest first
          </label>
          <label htmlFor="Oldest" onClick={() => handleSortChange("Oldest")}>
            <input
              type="radio"
              id="Oldest"
              value="Oldest"
              checked={sortOption === "Oldest"}
              readOnly
              onChange={() => handleSortChange("Oldest")}
            />
            Oldest first
          </label>
          {
            !ismultipleassignment && role === "Teacher" && (
              <>
                           <label htmlFor="Score: Low to High" onClick={() => handleSortChange("Score: Low to High")}>
            <input
              type="radio"
              id="Score: Low to High"
              value="Score: Low to High"
              checked={sortOption === "Score: Low to High"}
              readOnly
              onChange={() => handleSortChange("Score: Low to High")}
            />
Score: Low to High
          </label>
               <label htmlFor="Score: High to Low" onClick={() => handleSortChange("Score: High to Low")}>
            <input
              type="radio"
              id="Score: High to Low"
              value="Score: High to Low"
              checked={sortOption === "Score: High to Low"}
              readOnly
              onChange={() => handleSortChange("Score: High to Low")}
            />
Score: High to Low
          </label>
              </>
            )
}
        </div>
      )}
    </>
  );
};

export default SortPopup;
